/* eslint-disable prettier/prettier, react/prop-types */
import { Form, Input } from "antd"
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../components/buttons/buttons";
import { DataSubmit, DataUpdate } from "../../redux/jobDescription/actionCreator";

export function AddEditjobDescription({ data, handleClose }) {

    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { loading } = useSelector(store => store.jobDescription)

    const handleSubmit = (values) => {

        if (data) {
            dispatch(DataUpdate(data.id, values, (isSuccess) => {
                if (isSuccess) {
                    handleClose();
                }
            }))
        } else {
            dispatch(DataSubmit(values, (isSuccess) => {
                if (isSuccess) {
                    handleClose();
                }
            }))
        }
        form.resetFields();
    }

    return <Form
        layout="vertical"
        initialValues={data}
        form={form}
        onFinish={handleSubmit}
    >
        <Form.Item label="Description" name="descriptionName" rules={[{ required: true }]}>
            <Input className="rounded-6" placeholder="Enter description" />
        </Form.Item>

        <Form.Item>
            <div className="flex items-center min-md:justify-end justify-center mt-[15px]">
                <Button
                    className="bg-regularBG dark:bg-regularBGdark h-[38px] ltr:mr-[20px] rtl:ml-[20px] px-[22px] text-[15px] text-body dark:text-white60 hover:text-light font-normal border-regular dark:border-white10"
                    onClick={() => {
                        return form.resetFields();
                    }}
                >
                    Reset
                </Button>
                <Button
                    htmlType="submit"
                    type="primary"
                    loading={loading}
                    className="bg-primary hover:bg-primary-hover h-[38px] px-[22px] text-[15px] text-white dark:text-white87 font-normal border-primary"
                >
                    {data ? "Update" : "Create"}
                </Button>
            </div>
        </Form.Item>
    </Form>
}
